import event1 from "../images/event1.png";
import e from '../images/dummye.jpeg';

const events = [
  {
    title: "Speaker Session",
    date: "8th October",
    img: event1,
    link: "",
  },
  {
    title: "Coming Soon!",
    date: "Coming Soon!",
    img: e,
    link: "",
  },
  {
    title: "Coming Soon!",
    date: "Coming Soon!",
    img: e,
    link: "",
  },
];

export default events;
